import React from 'react';
import { motion } from 'framer-motion';
import './LegalPage.css';

const PrivacyPage = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1>מדיניות פרטיות</h1>
            <p className="legal-subtitle">
              AIweon מחויבת להגנה על פרטיות המשתמשים שלה
            </p>
            <p className="legal-updated">עדכון אחרון: פברואר 2025</p>
          </motion.div>
        </div>
      </section>

      <div className="legal-content">
        {/* Introduction */}
        <section className="legal-section">
          <h2>כללי</h2>
          <p>
            ברוכים הבאים למדיניות הפרטיות של AIweon (להלן: "הפלטפורמה", "אנחנו" או "החברה").
            מדיניות זו מתארת כיצד אנו אוספים, משתמשים, מאחסנים ומגנים על המידע האישי שלכם
            בהתאם לחוק הגנת הפרטיות, התשמ"א-1981 ותקנות הגנת הפרטיות (אבטחת מידע), התשע"ז-2017.
          </p>
          <p>
            AIweon היא פלטפורמת שיווק משפיענים המחברת בין יוצרי תוכן לבין מותגים ומפרסמים.
            שימוש בפלטפורמה מהווה הסכמה לתנאי מדיניות פרטיות זו.
          </p>
        </section>

        {/* Data Collection */}
        <section className="legal-section">
          <h2>המידע שאנו אוספים</h2>

          <h3>מידע שאתם מספקים לנו</h3>
          <ul>
            <li>פרטי זיהוי: שם מלא, כתובת דוא"ל, מספר טלפון</li>
            <li>פרטי פרופיל: תמונת פרופיל, ביוגרפיה, תחומי עניין וקטגוריות תוכן</li>
            <li>מידע מקצועי ליוצרי תוכן: קישורים לרשתות חברתיות, מספרי עוקבים, פלטפורמות פעילות, דוגמאות עבודה קודמות</li>
            <li>מידע עסקי למותגים: שם חברה, לוגו, תעשייה, אתר אינטרנט</li>
            <li>תוכן שאתם יוצרים: הגשות לקמפיינים, הודעות, העלאות קבצים</li>
          </ul>

          <h3>מידע שנאסף באופן אוטומטי</h3>
          <ul>
            <li>כתובת IP ומיקום גיאוגרפי כללי</li>
            <li>סוג דפדפן ומערכת הפעלה</li>
            <li>דפי כניסה ויציאה, זמני גלישה ופעולות בפלטפורמה</li>
            <li>מזהי התקן ועוגיות (Cookies)</li>
          </ul>
        </section>

        {/* Purpose of Use */}
        <section className="legal-section">
          <h2>מטרות השימוש במידע</h2>
          <p>אנו משתמשים במידע שנאסף למטרות הבאות:</p>
          <ul>
            <li>הפעלת הפלטפורמה ומתן השירותים — רישום, ניהול חשבון, התאמת יוצרים לקמפיינים</li>
            <li>תקשורת עם משתמשים — עדכונים על קמפיינים, הגשות, הודעות מערכת</li>
            <li>שיפור השירות — ניתוח דפוסי שימוש, אופטימיזציה של חווית המשתמש</li>
            <li>אבטחת הפלטפורמה — מניעת הונאות, זיהוי שימוש לרעה, אימות זהות</li>
            <li>עמידה בדרישות חוקיות ורגולטוריות</li>
            <li>שליחת תוכן שיווקי — בכפוף להסכמתכם בלבד, ובאפשרותכם לבטל בכל עת</li>
          </ul>
        </section>

        {/* Data Sharing */}
        <section className="legal-section">
          <h2>שיתוף מידע עם צדדים שלישיים</h2>
          <p>אנו לא מוכרים את המידע האישי שלכם. מידע ישותף אך ורק במקרים הבאים:</p>
          <ul>
            <li><strong>בין משתמשי הפלטפורמה:</strong> פרטי פרופיל של יוצרים מוצגים למותגים שפרסמו קמפיינים, ולהפך — פרטי הקמפיין והמותג מוצגים ליוצרים. מידע זה הכרחי לפעילות הפלטפורמה.</li>
            <li><strong>ספקי שירות:</strong> שירותי אחסון ענן (Google Cloud), מסדי נתונים (Supabase), שליחת מיילים — כולם מחויבים לשמירה על פרטיות המידע.</li>
            <li><strong>דרישה חוקית:</strong> ככל שנדרש על פי חוק, צו בית משפט או הליך משפטי.</li>
            <li><strong>הגנה על זכויות:</strong> מניעת הונאה, אכיפת תנאי השימוש, או הגנה על בטיחות המשתמשים.</li>
          </ul>
        </section>

        {/* Data Security */}
        <section className="legal-section">
          <h2>אבטחת מידע</h2>
          <p>
            אנו נוקטים באמצעי אבטחה מתקדמים להגנה על המידע שלכם, בהתאם לתקנות הגנת הפרטיות
            (אבטחת מידע), התשע"ז-2017, לרבות:
          </p>
          <ul>
            <li>הצפנת סיסמאות בטכנולוגיית bcrypt</li>
            <li>תקשורת מוצפנת באמצעות HTTPS/TLS</li>
            <li>אימות משתמשים באמצעות JWT (JSON Web Tokens)</li>
            <li>הגבלת גישה מבוססת תפקידים (יוצר תוכן, מותג, מנהל)</li>
            <li>הגנה מפני התקפות נפוצות כולל Rate Limiting, CORS ו-Helmet</li>
            <li>סינון וולידציה של קלטים למניעת SQL Injection ו-XSS</li>
          </ul>
          <p>
            על אף מאמצי האבטחה שלנו, אין שיטת אבטחה מושלמת. במקרה של פרצת אבטחה המשפיעה
            על המידע האישי שלכם, נפעל בהתאם לחוק ונודיע לכם בהקדם האפשרי.
          </p>
        </section>

        {/* User Rights */}
        <section className="legal-section">
          <h2>זכויות המשתמש</h2>
          <p>
            בהתאם לחוק הגנת הפרטיות, עומדות לכם הזכויות הבאות:
          </p>
          <ul>
            <li><strong>זכות עיון:</strong> לעיין במידע האישי שנשמר עליכם במאגרי המידע שלנו.</li>
            <li><strong>זכות תיקון:</strong> לבקש תיקון מידע שגוי או לא מעודכן.</li>
            <li><strong>זכות מחיקה:</strong> לבקש מחיקת המידע האישי שלכם, בכפוף לחובות חוקיות שחלות עלינו.</li>
            <li><strong>זכות התנגדות:</strong> להתנגד לשימוש במידע שלכם למטרות שיווק ישיר.</li>
            <li><strong>זכות ניוד:</strong> לקבל את המידע שלכם בפורמט מובנה ונפוץ.</li>
          </ul>
          <p>
            לצורך מימוש זכויותיכם, אנא פנו אלינו באמצעות פרטי הקשר המופיעים בתחתית דף זה.
            נשיב לפנייתכם תוך 30 ימים כנדרש בחוק.
          </p>
        </section>

        {/* Data Retention */}
        <section className="legal-section">
          <h2>תקופת שמירת מידע</h2>
          <p>
            אנו שומרים את המידע האישי שלכם כל עוד חשבונכם פעיל או ככל שנדרש לצורך מתן השירותים.
            לאחר מחיקת חשבון, מידע אישי יימחק או יעבור אנונימיזציה תוך 90 ימים, למעט מידע
            שעלינו לשמור לצורך עמידה בדרישות חוקיות, יישוב מחלוקות, או אכיפת ההסכמים שלנו.
          </p>
        </section>

        {/* Cookies */}
        <section className="legal-section">
          <h2>עוגיות (Cookies)</h2>
          <p>הפלטפורמה משתמשת בעוגיות לצורך:</p>
          <table className="legal-table">
            <thead>
              <tr>
                <th>סוג העוגייה</th>
                <th>מטרה</th>
                <th>משך</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>עוגיות הכרחיות</td>
                <td>אימות משתמשים, שמירת סשן, אבטחה</td>
                <td>עד לסגירת הדפדפן / 7 ימים</td>
              </tr>
              <tr>
                <td>עוגיות פונקציונליות</td>
                <td>שמירת העדפות שפה ותצוגה</td>
                <td>עד שנה</td>
              </tr>
              <tr>
                <td>עוגיות אנליטיות</td>
                <td>ניתוח שימוש ושיפור חווית המשתמש</td>
                <td>עד שנתיים</td>
              </tr>
            </tbody>
          </table>
          <p>
            ניתן לנהל את העוגיות דרך הגדרות הדפדפן שלכם. שימו לב כי חסימת עוגיות הכרחיות
            עלולה לפגוע בפעילות התקינה של הפלטפורמה.
          </p>
        </section>

        {/* International Data Transfer */}
        <section className="legal-section">
          <h2>העברת מידע מחוץ לישראל</h2>
          <p>
            חלק מהשירותים בהם אנו משתמשים (כגון שירותי ענן ואחסון) עשויים לשמור מידע בשרתים
            מחוץ לישראל. במקרים אלו, אנו מוודאים כי ההעברה מתבצעת בהתאם לתקנות הגנת הפרטיות
            (העברת מידע אל מאגרי מידע שמחוץ לגבולות המדינה), התשס"א-2001, וכי המדינה
            המקבלת מספקת רמת הגנה נאותה על מידע אישי.
          </p>
        </section>

        {/* Minors */}
        <section className="legal-section">
          <h2>קטינים</h2>
          <p>
            הפלטפורמה מיועדת למשתמשים מעל גיל 18 בלבד. אנו לא אוספים ביודעין מידע מקטינים
            מתחת לגיל 18. אם נודע לנו כי נאסף מידע של קטין, נפעל למחיקתו לאלתר.
            אם אתם הורים או אפוטרופוסים ומודעים לכך שילדכם סיפק לנו מידע אישי,
            אנא פנו אלינו.
          </p>
        </section>

        {/* Policy Changes */}
        <section className="legal-section">
          <h2>שינויים במדיניות</h2>
          <p>
            אנו עשויים לעדכן מדיניות זו מעת לעת. במקרה של שינויים מהותיים, נודיע לכם
            באמצעות הודעה בפלטפורמה או בדוא"ל. המשך השימוש בפלטפורמה לאחר העדכון
            מהווה הסכמה למדיניות המעודכנת.
          </p>
        </section>

        {/* Contact */}
        <section className="legal-section">
          <h2>יצירת קשר</h2>
          <p>לכל שאלה, בקשה או תלונה בנוגע למדיניות הפרטיות או לטיפול במידע האישי שלכם:</p>
          <div className="legal-contact-card">
            <h3>AIweon — ממונה פרטיות</h3>
            <p>דוא"ל: <a href="mailto:privacy@aiweon.com">privacy@aiweon.com</a></p>
            <p>טלפון: <a href="tel:+972522398911">052-239-8911</a></p>
            <p>
              בנוסף, אתם רשאים לפנות לרשות להגנת הפרטיות (ILPA) בכל שאלה או תלונה בנושא
              הגנת המידע האישי שלכם.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPage;
